

export class DefaultReducerHandlers {

    public static set(state: any, action: any): any {
        return action.payload;
    }

    public static override(state: any, action: any): any {
        return {...state, ...action.payload};
    }

    public static noop(state: any, action: any): any {
        return state;
    }
}
